import React, { useEffect, useState } from "react";
import { 
    Heading,
    Flex,
    Box,
    Image,
    SimpleGrid,
    Text,
    Stack,
    Link,
    Divider, 
    Grid,
    Button,
    HStack
} from "@chakra-ui/react";
import { GiPresent } from "react-icons/gi"
import axios from 'axios';
import CommonVars from "../components/CommonVars";
import Products from "../components/Products";

function HomeScreen() {
    const [category, setCategory] = useState('');

    console.log(CommonVars.API_URL);

    // get all category from server
    const getCategory = async () => {
        axios.get(`${CommonVars.API_URL}/category`)
        .then((res) => {
            console.log(res.data);
            setCategory(res.data);
        })
        .catch((err) => {
            console.log(err);
        })
    }

    useEffect(() => {
        getCategory();
    }, []);

    const aCategory = [];

    for(var j = 0; j < category.length; j++) {
        aCategory.push(
            <Box 
                className="category"
                key={category[j].categoryid}
                px={1}
            >
                <a href={'/category/' + category[j].categoryid + '/products'}>
                    <Image
                        className="catImages"
                        w={400}
                        h={285}
                        src={category[j].category_img_url}
                        alt={`Picture of ${category[j].categoryname}`}
                        py={2}
                    />
                    <Box 
                        className="catCenter"
                        bg={'#f4f4f4'}
                        py={2}
                        px={3}
                    >
                        <Text
                            textAlign="center"
                            fontSize={22}
                            textTransform={'uppercase'}
                            fontWeight={'medium'}
                        >
                            {category[j].categoryname}
                        </Text>
                    </Box>
                </a>
            </Box>
        )
    }

    return (
        <div className='Main'>
            {/* Website Banner */}
            <Box
                bg="linear-gradient(#101010, #3f3f3f)"
                backgroundRepeat = 'no-repeat'
                backgroundAttachment={'fixed'}
                minH={'63vh'}
                pt = '3.5rem'
                px = '14rem'
            >
                <Grid templateColumns='repeat(2, 1fr)'>
                        <Stack direction = 'column'  justify = 'center' color = 'white'>
                            <Text color={'gray.400'}>WLD Watches Online</Text>
                            <Heading
                                fontSize = '6xl'
                            >
                                Introducing our New Collection!
                            </Heading>
                            <Text>
                                Explore on the watches and accessories we got to offer!
                            </Text>
                        </Stack>
                        <Image
                            src = 'img/watchbanner1.png'
                        />
                </Grid>

            </Box>
            <div className="main-page" id = 'main-page'>
                <Box 
                    align={'center'}
                    pt={2}
                >
                    <Heading textTransform={'uppercase'}>Our Collections</Heading>
                    <Text fontSize={20} pt={2}>An Endless Plethora of Choices</Text>
                    <Flex 
                        direction="row" 
                        py={12}
                        justifyContent={"center"}
                    >
                        <SimpleGrid 
                            columns={{ sm: 1, md: 2, lg: 2}} 
                            columnGap={{ md: 6, lg: 20 }}
                        >
                            {aCategory}
                        </SimpleGrid>
                    </Flex>
                </Box>
                <div className="divider">
                    <Divider orientation='horizontal' borderColor={'gray.300'} pt={4}/>
                </div>
                <Box
                    align={'center'}
                    pt={14}
                >
                    <Heading textTransform={'uppercase'}>Our Products</Heading>
                    <Text fontSize={20} pt={2}>A Timeless Collection of Timepieces</Text>
                </Box>
                <Box 
                    px={{ lg: 12, xl: 24 }}
                    pt={10}
                    pb={3}
                >
                    <SimpleGrid
                        columns={{ sm: 1, md: 2, xl: 4 }}
                        columnGap={{ base: 4, md: 6 }}
                        rowGap={{ base: 8, md: 10 }}
                        alignContent="center"
                    >
                        <Products />
                    </SimpleGrid>
                </Box>
            </div>
            <Box 
                bg={'#e8e9eb'}
                minH={'40vh'}
            >
                <Box
                    pt={12}
                >
                    <Flex
                        align={'center'}
                        justify={'center'}
                    >
                        <HStack spacing={12}>
                            <Box>
                                <Heading pb={1}>SAVE MONEY </Heading>
                                <Heading pb={2}>ON YOUR NEXT OFFER!</Heading>
                                <Text fontSize={20}>Win discount codes by playing a memory game.</Text>
                                {
                                    localStorage.getItem('token') === null || localStorage.getItem('userDetails') === null ? 
                                    <Box pt={4}><Button colorScheme='telegram'><Link href="/login">Login to play</Link></Button></Box> : 
                                    <Box pt={4}><Button colorScheme='telegram'><Link href={`/user/${JSON.parse(localStorage.getItem('userDetails')).userid}/game`}>Play Game</Link></Button></Box>
                                }
                            </Box>
                            <Box>
                                <GiPresent size={200}/>
                            </Box>
                        </HStack>
                    </Flex>
                </Box>
            </Box>
        </div>
    )
}

export default HomeScreen;